export default __webpack_public_path__ + "static/media/q11_new.f64c114e.png";